/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseConversationAutomationStatus } from '../../models/api-response-conversation-automation-status';

export interface GetConversationAutomationStatus$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  conversationReference: string;
}

export function getConversationAutomationStatus(http: HttpClient, rootUrl: string, params: GetConversationAutomationStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseConversationAutomationStatus>> {
  const rb = new RequestBuilder(rootUrl, getConversationAutomationStatus.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('conversationReference', params.conversationReference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseConversationAutomationStatus>;
    })
  );
}

getConversationAutomationStatus.PATH = '/api/ai-assistant/conversation/{conversationReference}/status';
